import React from 'react'
import css from '@emotion/css'

import { FS_S, WHITE, EXPO_EASE_OUT } from '../css/style'

import purpleDeezer from '../images/brush-deezer.png'

const Button = ({ customCss, isButtonVisible, handleClick, svg, text }) => {
    return (
        <button
            onClick={() => handleClick()}
            css={[buttonClass, bgClassFn({ svg }), customCss]}
            className={isButtonVisible ? 'is-visible' : ''}
            data-text={text}
        >
            <span />
            <div />
        </button>
    )
}

const bgClassFn = props => css`
    background-image: url(${props.svg});
    background-position: 54% 50%;
    background-repeat: no-repeat;
    background-size: 25%;
`

const buttonClass = css`
    color: ${WHITE};
    cursor: pointer;
    font-size: ${FS_S};
    font-weight: 600;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    text-align: center;
    text-transform: uppercase;
    transition: opacity 1s linear;

    white-space: nowrap;

    &::after {
        content: attr(data-text);
        left: 50%;
        position: absolute;
        top: 98px;
        transform: translateX(-50%);
    }

    > span {
        border: 1px solid ${WHITE};
        border-radius: 50%;
        display: block;
        height: 80px;
        transition: transform 0.6s ${EXPO_EASE_OUT};
        width: 80px;
    }

    > div {
        height: 38px;
        top: 86px;
        left: -27px;
        overflow: hidden;
        position: absolute;
        transform: skew(-10deg);
        transition: width 0.6s ${EXPO_EASE_OUT};
        width: 0;

        & ::after {
            background-image: url(${purpleDeezer});
            background-size: cover;
            content: '';
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            width: 130px;
            z-index: -1;
        }
    }

    &.is-visible {
        opacity: 1;
        pointer-events: auto;
    }

    &:hover {
        > span {
            transform: scale(1.1);
        }
        > div {
            width: 130px;
        }
    }
`

export default Button
